export const AFFILIATED_LINK_DATA_TYPE = "huit-affiliate";
